module.exports = __webpack_public_path__ + "static/img/banner.4f1fdfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gift/banner.jpg
// module id = sBTM
// module chunks = 1